import '.ax{padding:222px 96px 96px 96px;}.ssr-plugin'
import '.ay{overflow:hidden;}.ssr-plugin'
import '.f{flex:1;}.ssr-plugin'
import '.az{min-height:100dvh;}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.ak{margin:0 auto;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.b0{max-width:1280px;}.ssr-plugin'
import '.a{width:100%;}.ssr-plugin'
import '.b1{gap:144px;}.ssr-plugin'
import '.b2{min-width:0px;}.ssr-plugin'
import '.b3{margin-bottom:16px;}.ssr-plugin'
import '.b4{opacity:0;}.ssr-plugin'
import '.b5{animation:cart-title-slide-in 0.6s ease-out forwards;}.ssr-plugin'
import '.v{align-items:center;}.ssr-plugin'
import '.am{justify-content:space-between;}.ssr-plugin'
import '.b6{margin-bottom:72px;}.ssr-plugin'
import '.b7{margin-bottom:8px;}.ssr-plugin'
import '.b8{max-width:148px;}.ssr-plugin'
import '.b9{margin-bottom:48px;}.ssr-plugin'
import '.ba{animation:cart-title-slide-in 0.6s ease-out 0.2s forwards;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.bc{border-radius:40px;}.ssr-plugin'
import '.bd{gap:24px;}.ssr-plugin'
import '.be{padding:72px;}.ssr-plugin'
import '.aw{text-align:center;}.ssr-plugin'
import '.ap{position:relative;}.ssr-plugin'
import '.bf{max-width:568px;}.ssr-plugin'
import '.bg{aspect-ratio:1/1;}.ssr-plugin'
import { useEffect, type ReactNode } from 'react'
import { styled } from 'inlines'
import { colors } from '../utils/colors.js'
import { Button } from '../components/Button.js'
import { Icon } from '../assets/icons/index.js'
import { Meter } from '../components/Meter.js'
import { SingleCartItem } from '../components/SingleCartItem.js'
import { useTrack } from '../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../shared/analyticsEvents.js'
import { useLocation } from 'wouter'
import { useLive } from '../hooks/useLive.js'
import { usePhoneVotesCast } from '../hooks/usePhoneVotesCast.js'
import { transparentColor } from '../utils/transparentcolor.js'
import { TABLET, MOBILE } from '../utils/breakpoints.js'
import { useLanguage } from '../hooks/useLanguage.js'
import { replaceCurrencyCodes } from '../utils/currencyDisplay.js'
import { useScrollToTop } from '../hooks/useScrollToTop.js'
import { useDictionary } from '../hooks/useDictionary.js'
import { InfoRow } from '../components/InfoRow.js'

const userAgent = navigator.userAgent
const isAndroid = /android/i.test(userAgent)
const divider = isAndroid ? '?' : '&'
const voteTag = 'voted via esc.vote!'

type CartPageProps = {
  votes?: Record<string, number>
  setVotes?: (selected: Record<string, number>) => void
}

export const CartPage = ({ votes, setVotes }: CartPageProps) => {
  const [, setLocation] = useLocation()
  const [lang] = useLanguage()
  const { votingRegion, contestants, round, rounds } = useLive()
  const currentRound = (rounds as unknown as any[])?.find?.(
    (r: any) => r.id === round?.id,
  )
  const ddiByRegion: Record<string, string> = {}
  for (const c of currentRound?.contestants ?? []) {
    ddiByRegion[c.votingRegionCode] = c.ddi
  }

  const { voteType, maxVotes, price, currencySymbol, votingText, votingLegal } =
    votingRegion

  const {
    yourCart,
    total,
    vote,
    votes: dicVotes,
    callNowButton,
    sendSMSButton,
    callNowDescription,
    sendSMSDescription,
    checkoutButton,
    paymentMethodsNotice,
  } = useDictionary()

  useScrollToTop()

  const [phoneVotesCast, setPhoneVotesCast] = usePhoneVotesCast()

  if (votes === undefined) console.warn('CartPage: votes missing')
  const totalVotes = Object.values(votes ?? {}).reduce((a, b) => a + b, 0) // SAFE: empty object when votes not yet loaded

  const isPhoneVote = voteType !== 'online'
  const isCallVoting = voteType === 'call_suffix'
  const isCartEmpty = totalVotes === 0
  if (maxVotes === undefined) console.warn('CartPage: maxVotes missing')
  const maxed = totalVotes >= (maxVotes ?? 0) // SAFE: zero when maxVotes not yet loaded

  const votedRegion = votes ? Object.keys(votes)?.[0] : ''

  const track = useTrack('cart')

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD, `cart-${totalVotes}votes`)
  }, [track])

  return (
    <styled.div className="ax ay f az ag"
      style={{
        [TABLET]: {
          padding: '142px 48px 92px 48px',
        },
        [MOBILE]: {
          padding: '124px 16px 92px 16px',
        },
      }}
    >
      <style>{`
        @keyframes cart-title-slide-in {
          from { opacity: 0; transform: translateY(48px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
      <styled.div className="ak o b0 a b1"
        id="cart-page-content"
        style={{
          [TABLET]: {
            flexDirection: 'column',
            gap: '72px',
          },
        }}
      >
        {/* Left Column */}
        <div className="f b2">
          <h2 className="b3 b4 b5"
          >
            {yourCart}
          </h2>
          {isPhoneVote ? (
            <PhoneVotingColumn
              isCallVoting={isCallVoting}
              maxVotes={maxVotes}
              votingText={votingText}
              votingLegal={votingLegal}
            />
          ) : (
            <OnlineVotingColumn totalVotes={totalVotes} maxVotes={maxVotes} />
          )}
        </div>

        {/* Right Column */}
        {isCartEmpty ? (
          <EmptyCartContainer />
        ) : (
          <div className="f b2"
            id="cart-page-votes-overview"
          >
            {contestants
              .filter((item) => votes?.[item.votingRegion])
              .map((item) => (
                <SingleCartItem
                  isPhone={isPhoneVote}
                  key={item.votingRegion}
                  item={item}
                  votes={votes}
                  setVotes={setVotes}
                  maxed={maxed}
                  price={price}
                  currency={currencySymbol}
                  lang={lang.code}
                  ddi={ddiByRegion[votedRegion]}
                />
              ))}
            <div className="o v am b6"
              id="cart-page-total-line"
            >
              <p>
                {total} ({totalVotes} {totalVotes === 1 ? vote : dicVotes})
              </p>
              <p>
                {currencySymbol}{' '}
                {(() => {
                  if (price === undefined)
                    console.warn('CartPage: price missing')
                  return (((price ?? 0) * totalVotes) / 100).toFixed(2) // SAFE: zero when price not yet loaded
                })()}
              </p>
            </div>
            {isPhoneVote ? (
              <styled.div>
                <Button
                  id="cart-page-phone-action-button"
                  style={{ marginBottom: 24 }}
                  onClick={() => {
                    const voted = contestants.find(
                      (c) => votes?.[c.votingRegion],
                    )

                    phoneVotesCast[voted?.votingRegion] ??= 0
                    phoneVotesCast[voted?.votingRegion]++
                    setPhoneVotesCast({ ...phoneVotesCast })

                    // SMS OR CALL LOGIC
                    let voteLink: string = ''
                    let ddi = ddiByRegion[voted?.votingRegion] ?? '00'

                    if (votingRegion.voteType === 'sms_text') {
                      voteLink = `sms:${votingRegion.destination}${divider}body=${ddi} ${voteTag}`
                    } else if (votingRegion.voteType === 'sms_suffix') {
                      voteLink = `sms:${votingRegion.destination}${ddi}${divider}body=${voteTag}`
                    } else if (votingRegion.voteType === 'call_suffix') {
                      voteLink = `tel:${votingRegion.destination}${ddi}`
                    } else if (votingRegion.voteType === 'sms_keyword') {
                      voteLink = `sms:${votingRegion.destination}${divider}body=CANCION${ddi} ${voteTag}`
                    }

                    window.open(encodeURI(voteLink), '_self')
                    const controller = new AbortController()
                    window.addEventListener(
                      'focus',
                      () => {
                        setTimeout(() => setLocation(`/thank-you/${voted?.id}`))
                      },
                      { signal: controller.signal },
                    )
                  }}
                >
                  {isCallVoting ? callNowButton : sendSMSButton}
                </Button>
                <p className="subtext">
                  {isCallVoting ? callNowDescription : sendSMSDescription}
                </p>
              </styled.div>
            ) : (
              <>
                <Button
                  id="cart-page-action-continue-to-checkout"
                  trailIcon={
                    <Icon type="forwardIcon" color={colors.secondary} />
                  }
                  style={{ marginBottom: 24 }}
                  onClick={() => setLocation('/checkout')}
                >
                  {checkoutButton}
                </Button>
                <p className="subtext b7">
                  {paymentMethodsNotice}
                </p>
                <img className="b8"
                  src="https://files-baseddb-saulx-esc2026-production-en-e-e-ko51x0.based.dev/nqwqb6/4b9cbfa0-1650-47c0-a4ec-1ad7239cd944-1afaaa52-b5a5-409b-94b2-5a79230cf68b-1a533770-f151-4ad1-b4ea-d5e79bd7fae3.png"
                />
              </>
            )}
          </div>
        )}
      </styled.div>
    </styled.div>
  )
}

type OnlineVotingColumnProps = {
  totalVotes: number
  maxVotes: number | undefined
}

const OnlineVotingColumn = ({
  totalVotes,
  maxVotes,
}: OnlineVotingColumnProps) => {
  const {
    nOutOfMaxVotes,
    tutorialMaxVotes,
    tutorialVotePrice,
    tutorialCardLimit,
    tutorialLostVotes,
  } = useDictionary()

  return (
    <>
      <h1 className="b9 b4 ba"
        id="cart-page-vote-count"
        style={{
          color: colors.primary,}}
      >
        {nOutOfMaxVotes}
      </h1>
      <Meter
        value={(totalVotes / (maxVotes ?? 0)) * 100}
        style={{
          marginBottom: 24,
          maxWidth: 240,
          [MOBILE]: { maxWidth: '100%' },
        }}
      />
      <InfoRow>
        {' '}
        {tutorialMaxVotes?.replace(
          /{{maxVotes}}/g,
          maxVotes !== undefined ? String(maxVotes) : '',
        )}
      </InfoRow>
      <InfoRow>{tutorialVotePrice}</InfoRow>
      <InfoRow>{tutorialCardLimit}</InfoRow>
      <InfoRow>{tutorialLostVotes}</InfoRow>
    </>
  )
}

type PhoneVotingColumnProps = {
  isCallVoting: boolean
  maxVotes: number | undefined
  votingText: string | undefined
  votingLegal: string | undefined
}

const PhoneVotingColumn = ({
  isCallVoting,
  maxVotes,
  votingText,
  votingLegal,
}: PhoneVotingColumnProps) => {
  const {
    vote,
    onlyCallVotingSupported,
    onlySMSVotingSupported,
    thankYouCallSMSVoteLimit,
    maxedOutNotice,
  } = useDictionary()

  return (
    <>
      <h1 className="b9 b4 ba"
        style={{
          color: colors.primary,}}
      >
        1 {vote}
      </h1>
      <InfoRow>
        {isCallVoting ? onlyCallVotingSupported : onlySMSVotingSupported}
      </InfoRow>
      <InfoRow>
        {thankYouCallSMSVoteLimit}
        {maxedOutNotice}
      </InfoRow>
      <InfoRow>{replaceCurrencyCodes(votingText ?? '')}</InfoRow>
      <InfoRow>{replaceCurrencyCodes(votingLegal ?? '')}</InfoRow>
    </>
  )
}

const EmptyCartContainer = () => {
  const [, setLocation] = useLocation()
  const { emptyCartInstruction, addVotesButton } = useDictionary()

  return (
    <styled.div className="blur f o v bb p bc bd be aw ap bf a bg"
      style={{
        backgroundColor: transparentColor(colors.secondary, 0.3),
        border: `1px solid ${colors.border}`,
        [TABLET]: {
          aspectRatio: 'unset',
          textAlign: 'left',
          padding: '24px',
          maxWidth: 'calc(100% - 48px)',
          alignItems: 'flex-start',
        },
        [MOBILE]: {
          textAlign: 'center',
          alignItems: 'center',
        },
      }}
    >
      <p>{emptyCartInstruction}</p>
      <Button
        id="cart-page-empty-action-back-home"
        style={{
          [MOBILE]: {
            width: '100%',
            justifyContent: 'center',
          },
        }}
        leadIcon={<Icon type="addIcon" color={colors.secondary} />}
        onClick={() => setLocation('/')}
      >
        {addVotesButton}
      </Button>
    </styled.div>
  )
}
